import { useTemplatePageContent } from '@components/Components/Providers/TemplatePageContentContext';
import BoxContainerV2 from '@components/Components/Reusables/BoxContainerV2'
import { getSections } from '@components/config/helpers';
import ParseHtml from '@components/Custom/ParseHtml';
import Box from '@mui/material/Box';
import Grid from '@mui/material/GridLegacy';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

export default function PrivacyPolicy(props) {
    const { template_page_settings } = props;
    const router = useRouter();

    const { template_page_content, meta } = useTemplatePageContent();
    const page_content = template_page_content;

    useEffect(() => {
        page_content == null && router.push('404');
    }, [template_page_settings])


    if (page_content == null) {
        return <BoxContainerV2>Redirecting...</BoxContainerV2>
    }

    const sections = getSections(page_content);

    return (
        <BoxContainerV2 mobileClasses="pl-2 pr-2">
            <Head>
                <title>{meta.meta_title}</title>

                <meta
                    name="description"
                    content={meta.meta_description}
                />
            </Head>
            <div>
                <Grid spacing={1} rowSpacing={3} container
                >
                    {
                        Object.keys(sections).map((section) => (
                            <Grid key={section} xs={12} lg={12} item>
                                {sections[section].title && (
                                    <Box className="mb-2 fw-semi-bold" sx={{
                                        'p': {
                                            color: '#6d6868',
                                            fontSize: '18px',
                                        }
                                    }}>
                                        <ParseHtml html={sections[section].title} />
                                    </Box>
                                )}
                                {sections[section].content && (
                                    <Box sx={{
                                        'p': {
                                            color: '#6d6868',
                                            fontSize: '14px',
                                            lineHeight: '30px',
                                        }
                                    }}>
                                        <ParseHtml html={sections[section].content} />
                                    </Box>
                                )}
                            </Grid>
                        ))
                    }
                </Grid>
            </div>
        </BoxContainerV2>
    )
}
